import {changeFilteredInfo} from "@/utils/data/tableCol/tableUtils";

export const company = (filteredInfos,role) => {
    let filteredInfo = changeFilteredInfo(filteredInfos)
    return [
        {
            title: '操作',
            key: 'operation',
            scopedSlots: {customRender: 'operation'},
            width: 150
        },
        {
            title: '公司名称',
            dataIndex: 'companyName',
            key: 'companyName',
            scopedSlots: {
                customRender: 'copyInfoData',
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.companyName || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '地址',
            dataIndex: 'companyAddress',
            key: 'companyAddress',
            scopedSlots: {
                customRender: 'companyAddress'
            }
        },
        {
            title: '电话',
            dataIndex: 'phone',
            key: 'phone',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.phone || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '三方报价',
            dataIndex: 'threePartyQuotationStatus',
            key: 'threePartyQuotationStatus',
            scopedSlots: {
                customRender: 'threePartyQuotationStatus'
            },
        },
        {
            title: '是否暂停开票',
            dataIndex: 'companyInvoiceStatus',
            key: 'companyInvoiceStatus',
            scopedSlots: {
               customRender: 'companyInvoiceStatus'
            },
        },
        {
            title: '一年内已开发票金额',
            dataIndex: 'annualInvoicedAmount',
            key: 'annualInvoicedAmount',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            roles: ['BUSINESS_COMMERCIAL','ADMIN','MANAGER'],
            filteredValue: filteredInfo.annualInvoicedAmount || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '限额',
            dataIndex: 'quota',
            key: 'quota',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            roles: ['BUSINESS_COMMERCIAL','ADMIN','MANAGER'],
            filteredValue: filteredInfo.quota || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '合同负责人',
            dataIndex: 'contractPrincipal.name',
            key: 'contractPrincipal'
        },
        {
            title: '发票负责人',
            dataIndex: 'invoicingPrincipal.name',
            key: 'invoicingPrincipal'
        },
        {
            title: '行号',
            dataIndex: 'bankLineNumber',
            key: 'bankLineNumber',
            scopedSlots: {
                customRender: 'copyInfoData',
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.bankLineNumber || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '开户行',
            dataIndex: 'depositBank',
            key: 'depositBank',
            scopedSlots: {
                customRender: 'depositBank'
            }
        },
        {
            title: '银行账号',
            dataIndex: 'bankAccount',
            key: 'bankAccount',
            scopedSlots: {
                customRender: 'copyInfoData',
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.bankAccount|| [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '纳税人识别号',
            dataIndex: 'taxpayerNumber',
            key: 'taxpayerNumber',
            scopedSlots: {
                customRender: 'copyInfoData',
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.taxpayerNumber || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '备注',
            dataIndex: 'remark',
            key: 'remark',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true
            },
            filteredValue: filteredInfo.remark || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        }

    ].filter(item => item?.roles?.includes(role) || !item.roles)
}
